/*
 * @function: 跳转链接链路
*/
import { is } from '@didi/webx-js'
import { EventEmitter } from 'events'
import { openWaitView, updateDescText, updateTimerText, updateLink, removeView } from './ui'
import { trackEvent } from '../../trackEvent/index'

const defaultLinkArr = [{
  event: 'miniprogram',
  tip: '正在跳转小程序'
}, {
  event: 'passenger',
  tip: '正在打开APP'
}, {
  event: 'download',
  tip: '正在下载APP'
}]

// 百度链路
function baiduChain () {
  const linkArr = defaultLinkArr.slice()
  if (is('ios')) {
    linkArr.splice(0, 1)
  } else {
    linkArr.splice(1, 1)
  }
  return linkArr
}

// 默认链路
function defaultChain () {
  return defaultLinkArr.slice()
}

function getLinkArr (appUa) {
  let linkArr = []
  switch (appUa) {
    case 'baidu':
      linkArr = baiduChain()
      break
    default:
      linkArr = defaultChain()
      break
  }
  return linkArr
}

/**
 * @description: 根据event和配置的链接获取当前要跳转的链接
 * @param {*} event
 * @param {*} linkMap  配置的链接对象
 * @return {*}
 */
function getJumpLink (event, linkMap) {
  let link = null
  switch (event) {
    case 'miniprogram':
      link = linkMap.link_mp
      break
    case 'passenger':
      link = linkMap.link_app
      break
    case 'download':
      if (is('ios')) {
        link = linkMap.link_ios_download
      } else {
        link = linkMap.link_android_download
      }
      break
    default:
      break
  }
  return link
}

/**
 * @description: 解析浏览器ua标识
 */
function parseUserAgent () {
  const ua = window.navigator.userAgent
  const regs = {
    baidu: /baidu/i
  }
  const ret = {}

  for (const key in regs) {
    ret[key] = regs[key].test(ua)
  }
  return ret
}

/**
 * @description: 获取当前所在的APP
 */
function getAppUserAgent () {
  const userAgent = parseUserAgent()
  let appUa = ''
  for (const key in userAgent) {
    if (userAgent[key]) {
      appUa = key
    }
  }
  return appUa
}

/**
 * @description: 跳转链路
 * @param {*}
 * @return {*}
 */
class Chain extends EventEmitter {
  constructor (linkArr, linkMap, timeout) {
    super()
    this.timer = null
    this.handlers = {}
    this.linkArr = linkArr
    this.linkMap = linkMap
    this.timeout = timeout
    this.index = 0
  }

  start () {
    openWaitView({
      startJump: () => {
        // this.startJump(link)
      },
      timeoutCallback: (link) => {
        this.startJump(link)
      },
      closeCallback: () => {
        this.closeJump()
      },
      clickCallback: (link) => {
        this.startJump(link)
      }
    })
    const event = this.linkArr[this.index].event
    const link = getJumpLink(event, this.linkMap)
    this.startJump(link)
    this.countDown()
    // 埋点：半弹窗展现
    trackEvent('userteam_ad_zj_countdown_sw')
  }

  countDown () {
    if (this.index >= this.linkArr.length) {
      return this.closeJump()
    }
    const event = this.linkArr[this.index].event
    const link = getJumpLink(event, this.linkMap)
    if (!link) {
      this.index++
      return this.countDown()
    }
    // this.emit('changeTip', this.linkArr[this.index].tip)
    updateDescText(this.linkArr[this.index].tip)
    updateTimerText(this.timeout, link)
    updateLink(link)
  }

  startJump (link) {
    // 埋点：拉端动作
    trackEvent('userteam_ad_zj_diaoqi_bt')
    this.emit('jumpLink', link)
    this.checkPageStatus()
  }

  async checkPageStatus () {
    setTimeout(() => {
      if (document.hidden) {
        // 埋点：拉端成功
        trackEvent('userteam_ad_zj_diaoqi_success_bt')
        this.closeJump()
      } else {
        this.index++
        this.countDown()
      }
    }, 2000)
  }

  closeJump () {
    removeView()
  }

  changeTip (handler) {
    this.removeHandler('changeTip')
    this.addListener('changeTip', handler)
    this.handlers.changeTip = handler
  }

  jumpLink (handler) {
    this.removeHandler('jumpLink')
    this.addListener('jumpLink', handler)
    this.handlers.jumpLink = handler
  }

  removeHandler (handleName) {
    try {
      this.handlers[handleName] && this.removeListener(handleName, this.handlers[handleName])
    } catch (error) {
      console.log(error)
    }
  }
}

let chain = null

export default function (linkMap, timeout = 5000) {
  const appUa = getAppUserAgent()
  const linkArr = getLinkArr(appUa)
  if (!chain) {
    chain = new Chain(linkArr, linkMap, timeout)
  }
  return chain
}
